module.exports = __webpack_public_path__ + "img/bg-new-2.125b2455.png";